module.exports = __webpack_public_path__ + "static/anthony-bourdain-66875280bb88dc9ca58bcd9656c3865e.jpg";